import { FC } from "react";
import { useTranslation } from "react-i18next";
import SubscriptionForm from "./SubscriptionForm";
import ReferralLinkSection from "./ReferralLinkSection";
import SubscriptionAdvantagesSection from "./SubscriptionAdvantagesSection";

const SubscriptionPage: FC = () => {
    const { t } = useTranslation();

    return (
        <>
            <div className="relative mx-auto dmin2:w-[1280px] di6:w-[800px] ti6:w-[650px] ti7:w-[560px] tmax4:w-[360px] mb-[80px] dmax2:mb-[60px]">
                <h1 className="H32B dmax2:H24B text-textWhite mb-[50px] dmax2:mb-6">{t("subscription.title")}</h1>
                <SubscriptionForm />
                <ReferralLinkSection />
            </div>
            <div className="bg-[rgba(54,54,58,0.3)]">
                <div className="relative mx-auto dmin2:w-[1280px] di6:w-[800px] ti6:w-[650px] ti7:w-[560px] tmax4:w-[360px]">
                    <SubscriptionAdvantagesSection />
                </div>
            </div>
        </>
    );
};

export default SubscriptionPage;
